var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6292_5155)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.75 3.74994C4.45098 3.06284 5.39343 2.67798 6.375 2.67798C7.35657 2.67798 8.29902 3.06284 9 3.74994C9.70098 4.43704 10.6434 4.82191 11.625 4.82191C12.6066 4.82191 13.549 4.43704 14.25 3.74994V10.4999C13.549 11.187 12.6066 11.5719 11.625 11.5719C10.6434 11.5719 9.70098 11.187 9 10.4999C8.29902 9.81284 7.35657 9.42798 6.375 9.42798C5.39343 9.42798 4.45098 9.81284 3.75 10.4999V3.74994Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.75 15.75V10.5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6292_5155"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagIcon);
export default __webpack_public_path__ + "static/media/flagIcon.464d76b38e428389ad528e37bf3ff594.svg";
export { ForwardRef as ReactComponent };